<template>
  <footer class="section" data-section="footer">
    <div class="container" data-container="footer" data-toggle-footer-container>
      <div class="footer">
        <div class="footer__nav">
          <div class="f-nav footer__f-nav">
            <div class="footer__title">{{ $t('footer.services_title') }}</div>
            <div class="f-nav__list">
              <router-link
                :to="{ name: 'RestorePassword' }"
                class="f-nav__item"
                data-inner-select="restorePassword"
                >{{ $t('footer.restore_password') }}</router-link
              >
              <router-link
                :to="{ name: 'ChangePassword' }"
                class="f-nav__item"
                data-inner-select="changePassword"
                >{{ $t('footer.change_password') }}</router-link
              >
              <router-link
                :to="{ name: 'RestoreUsername' }"
                class="f-nav__item"
                data-inner-select="restoreUsername"
                >{{ $t('footer.restore_id') }}</router-link
              >
              <router-link
                :to="{ name: 'ChangeEmail' }"
                class="f-nav__item"
                data-inner-select="changeEmail"
                >{{ $t('footer.change_email') }}</router-link
              >
              <router-link
                :to="{ name: 'Unbind' }"
                class="f-nav__item"
                data-inner-select="unbind"
                >{{ $t('footer.unbind_hwid_ip') }}</router-link
              >
            </div>
          </div>
          <div class="f-nav footer__f-nav">
            <div class="footer__title">{{ $t('footer.support_title') }}</div>
            <div class="f-nav__list">
              <router-link
                :to="{ name: 'Contacts' }"
                class="f-nav__item"
                data-inner-select="contacts"
                >{{ $t('footer.contacts') }}</router-link
              >
              <a
                href="https://forum.la2dream.com/forum/5-faq/"
                target="_blank"
                class="f-nav__item"
                >{{ $t('footer.faq') }}</a
              >
              <a :href="sever_description" target="_blank" class="f-nav__item">{{
                $t('footer.information')
              }}</a>
              <router-link :to="{ name: 'Vote' }" class="f-nav__item" data-inner-select="vote">{{
                $t('footer.vote')
              }}</router-link>
              <router-link
                :to="{
                  name: 'Shop',
                  params: {
                    id:
                      this.$store.getters.get_current_server ||
                      this.$store.getters.get_default_server,
                  },
                }"
                class="f-nav__item"
                data-inner-select="shop"
                >{{ $t('footer.shop_link') }}</router-link
              >
            </div>
          </div>
          <div class="f-nav footer__f-nav">
            <div class="footer__title">{{ $t('footer.more_title') }}</div>
            <div class="f-nav__list">
              <router-link :to="{ name: 'Rules' }" class="f-nav__item" data-inner-select="rules">{{
                $t('footer.game_rules')
              }}</router-link>
              <router-link
                :to="{ name: 'UserAgreement' }"
                class="f-nav__item"
                data-inner-select="user_agreement"
                >{{ $t('footer.user_agreement') }}</router-link
              >
              <router-link
                :to="{ name: 'LicenseAgreement' }"
                class="f-nav__item"
                data-inner-select="license_agreement"
                >{{ $t('footer.license_agreement') }}</router-link
              >
              <router-link
                :to="{ name: 'G2AAgreement' }"
                class="f-nav__item"
                data-inner-select="g2a_agreement"
                >{{ $t('footer.g2a_additional_conditions') }}</router-link
              >
              <router-link
                :to="{ name: 'Statistics' }"
                data-inner-select="stats"
                class="f-nav__item"
                >{{ $t('footer.statistics') }}</router-link
              >
            </div>
          </div>
        </div>
        <!-- END  footer__nav -->
        <div class="footer__info">
          <div class="copyright">
            <div class="copyright__txt">
              <span class="copyright__site"
                >{{ $t('footer.copyright', { year: new Date().getFullYear() }) }}
              </span>
              {{ $t('footer.copyright_suffix') }}
            </div>
            <router-link
              :to="{ name: 'PrivacyAgreement' }"
              class="copyright__policy"
              data-inner-select="privacy_agreement"
              >{{ $t('footer.privacy_policy') }}</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import $ from 'jquery';

export default {
  name: 'FooterComponent',
  data() {
    return {
      speed: 300,
      body: $('body'),
      container: $('[data-toggle-footer-container]'),
    };
  },
  computed: {
    sever_description() {
      return this.$store.getters.get_server_description;
    },
  },
  methods: {
    toggle_footer() {
      this.$store.dispatch('toggle_footer');
    },
    footer_switcher(footer) {
      switch (footer) {
        case 0:
          $('[data-toggle-footer-container]').slideUp(this.speed, () => {
            if (!$('body').hasClass('footer-hide')) {
              $('body').addClass('footer-hide');
            }
            $(window).trigger('resize');
          });
          break;
        case 1:
          $('[data-toggle-footer-container]').slideDown(this.speed, () => {
            if ($('body').hasClass('footer-hide')) {
              $('body').removeClass('footer-hide');
            }
            $(window).trigger('resize');
          });
          break;
        default:
          console.error('switch default;');
          break;
      }
    },
  },
  beforeMount() {
    this.$store.dispatch('init_footer');
  },
  mounted() {
    let footer = null;

    try {
      footer =
        parseInt(this.$store.getters.get_footer) ||
        parseInt(this.$store.getters.get_footer_default);
      this.footer_switcher(footer);
    } catch (e) {
      footer = parseInt(this.$store.getters.get_footer_default);

      if (footer === 1) {
        this.container.slideUp(this.speed, () => {
          if (!this.body.hasClass('footer-hide')) {
            this.body.addClass('footer-hide');
          }
          $(window).trigger('resize');
        });
      }

      if (footer === 0) {
        this.container.slideDown(this.speed, () => {
          if (this.body.hasClass('footer-hide')) {
            this.body.removeClass('footer-hide');
          }
          $(window).trigger('resize');
        });
      }
    }
  },
};
</script>

<style scoped>
.copyright__policy {
  font-size: 0.75em;
}
</style>
